export default __webpack_public_path__ + "static/spaceship-0fb90e5c74479fab8449fd9608394584.png";